// 종목 기준 시세 알림 API (tb_stock_alert)
import axiosInstance from './axiosInstance';

export const fetchStockAlert = async (ticker) => {
  const res = await axiosInstance.get(`/stock-alert/${ticker}`);
  return res.data;
};

export const saveStockAlert = async (payload) => {
  const res = await axiosInstance.post('/stock-alert', payload);
  return res.data;
};

export const deleteStockAlert = async (ticker) => {
  const res = await axiosInstance.delete(`/stock-alert/${ticker}`);
  return res.data;
};
